import { css } from '@emotion/react';

export const BelfiusFont = css`
  @font-face {
    font-family: Belfius;
    font-weight: 700;
    font-display: swap;
    src: url('https://d1ngac5455aayn.cloudfront.net/fonts/BelfiusFont/WOFF2/BelfiusNormal_Bold.woff2')
      format('woff2');
  }
`;
